import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const CDN_URL = import.meta.env.VITE_CDN_URL || '';
const I18N_FOLDER = import.meta.env.VITE_STAFF_I18N_FOLDER || 'i18n/staff-beta';
const I18N_BASE_URL =
  import.meta.env.DEV || import.meta.env.VITE_I18N_LOCAL
    ? '/i18n'
    : CDN_URL
      ? `${CDN_URL}/${I18N_FOLDER}`
      : '/i18n';
const STORAGE_KEY = 'staff-language';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem(STORAGE_KEY) || 'en',
    fallbackLng: 'en',
    supportedLngs: ['en'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: `${I18N_BASE_URL}/{{lng}}.json`,
    },
    react: {
      useSuspense: false,
      bindI18nStore: 'added removed',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
    },
  });

export { STORAGE_KEY };
export default i18n;
